export default "__VITE_ASSET__2LNTmmni__";